import type { RouteObject } from 'react-router-dom'
import { LoginPage } from './LoginPage'
import { JoinPage, NewCompanyPage } from './CompanyPages'
import { TeamPage } from './TeamPage'
import { ProfilePage } from './ProfilePage'
import { ClaimsPage, ClaimTokenPage, InvitePage } from './ClaimPages'

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  // /partners (the partner sign-in short link) is in features/card/routes.tsx: the card-only app uses the path (CHANGE-073).
  { path: '/new', element: <NewCompanyPage /> },
  { path: '/join', element: <JoinPage /> },
  { path: '/team', element: <TeamPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/claims', element: <ClaimsPage /> },
  { path: '/claim/:token', element: <ClaimTokenPage /> },
  { path: '/invite/:token', element: <InvitePage /> },
]
